import { render } from "./LinkToService.vue?vue&type=template&id=87a76528&scoped=true&ts=true"
import script from "./LinkToService.vue?vue&type=script&lang=ts"
export * from "./LinkToService.vue?vue&type=script&lang=ts"

import "./LinkToService.vue?vue&type=style&index=0&id=87a76528&scoped=true&lang=css"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a76528"]])

export default __exports__